import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'

export default function startSession (sessionAuthToken = null) {
  if (sessionAuthToken) {
    /*
    * Give the session an authentication token to use from the URL.
    * This is used by rails to forward on a session, usually for SSO purposes.
    * We need this as some browsers block third party cookies, and some apps are
    * on different domains
    *
    * WARNING: Don't use this token for anything but initial auth
    */
    store.dispatch(profileSlice.authWithToken({ token: sessionAuthToken, includeAccount: true }))
  } else {
    store.dispatch(profileSlice.fetch({ includeAccount: true }))
  }
}
